(function($) {

    // Get Window Width and Height
    var windowWidth = $(window).outerWidth();
    var windowHeight = $(window).height();
  
    /* Document ready functions */
    jQuery(document).ready(function ($){
  
      // News post wrapper
      var swiper = new Swiper('.news .content', {
        allowTouchMove: false,
        slidesPerView: '3',
        breakpoints: {
              767: {
                  speed: 600,
                  centeredSlides: false,
                  allowTouchMove: true,
                  slidesPerView: '1',
                  spaceBetween: 15,
                  pagination: {
                      el: '.swiper-pagination',
                  },
              }
        }
      });

      // Frontpage slider
      var swiper2 = new Swiper('.carusell .frontpage-container', {
        loop: true,
        preloadImages: false,
        lazy: true,
        autoplay: {
          delay: 5500,
          disableOnInteraction: false,
        },
        pagination: {
            el: '.swiper-pagination',
        },
      });

      // Reference slider (category page)
      var swiper3 = new Swiper('.our-references .content', {
        slidesPerView: 'auto',
        spaceBetween: 0,
        preloadImages: false,
        lazy: true,
        loadPrevNext: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
      });

      // Reference image slider
      var swiper4 = new Swiper('.references-images', {
        slidesPerView: 'auto',
        spaceBetween: 0,
        preloadImages: false,
        lazy: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
      
      // Reference popup image slider
      var swiper4 = new Swiper('.popup-references-images', {
        slidesPerView: 'auto',
        spaceBetween: 0,
        preloadImages: false,
        lazy: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });

      // Blogpage image gallery
      var swiper5 = new Swiper('.post-content .swiper-container', {
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });

      // Section gallery slide
      var swiper6 = new Swiper('.gallery-block .swiper-container', {
        loop: true,
        slidesPerView: 1, 
        preloadImages: false,
        lazy: true,
        autoplay: {
          delay: 5500,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
      
    });
  
  })(jQuery);
  